import { Metric } from '../../../../dashboard-config/dashboard-config.model';
import {
  expandProductCatalog,
  ProductCatalogEntry,
} from '../../../_shared/dashboard-definition.model';
import { createDashboardTimeSeriesBarDefinition } from './create-dashboard-time-series-bar-definition';
import {
  TimeSeriesBarMetricProfile,
  timeSeriesBarCompaniesCountProfile,
  timeSeriesBarCompaniesRevenueProfile,
  timeSeriesBarEconomicParticipantProfile,
  timeSeriesBarEmployedProfile,
  timeSeriesBarGrossValueAddedProfile,
  timeSeriesBarSelfEmployedProfile,
  timeSeriesBarTourismProfile,
} from './dashboard-time-series-bar-metric.profile';
import { DashboardTimeSeriesBarShell } from './dashboard-time-series-bar-shell.profile';
import { DashboardTimeSeriesBarDefinition } from './dashboard-time-series-bar.definition';

/**
 * Product catalog for Zeitreihen bar dashboards.
 * Shell/metric profiles own behavior; this file owns which products exist.
 * Identity is derived in {@link createDashboardTimeSeriesBarDefinition}.
 */

export const TIME_SERIES_BAR_PRODUCT_CATALOG: Record<
  Metric,
  ProductCatalogEntry<TimeSeriesBarMetricProfile, DashboardTimeSeriesBarShell>
> = {
  [Metric.CompaniesCount]: {
    metric: timeSeriesBarCompaniesCountProfile,
    shells: ['states', 'wzClassStates', 'districts', 'subMarkets', 'districtSubMarkets', 'wzClasses', 'districtWzClasses'],
  },
  [Metric.CompaniesRevenue]: {
    metric: timeSeriesBarCompaniesRevenueProfile,
    shells: ['states', 'wzClassStates', 'districts', 'subMarkets', 'districtSubMarkets', 'wzClasses', 'districtWzClasses'],
  },
  [Metric.GrossValueAdded]: {
    metric: timeSeriesBarGrossValueAddedProfile,
    shells: ['states', 'wzClassStates', 'districts', 'subMarkets', 'districtSubMarkets', 'wzClasses', 'districtWzClasses'],
  },
  // No districtWzClasses from here on: Kreise × WZ-Klassen is bottom-up only, for Count, Revenue and GVA.
  [Metric.EconomicParticipant]: {
    metric: timeSeriesBarEconomicParticipantProfile,
    shells: ['states', 'wzClassStates', 'districts', 'subMarkets', 'districtSubMarkets', 'wzClasses'],
  },
  [Metric.Employed]: {
    metric: timeSeriesBarEmployedProfile,
    shells: ['states', 'wzClassStates', 'districts', 'subMarkets', 'districtSubMarkets', 'wzClasses'],
  },
  // Pending datasets: districts, districtSubMarkets (ts__d), wzClassStates, wzClasses (ts__wz).
  [Metric.SelfEmployed]: {
    metric: timeSeriesBarSelfEmployedProfile,
    shells: ['states', 'subMarkets'],
  },
  [Metric.Tourism]: {
    metric: timeSeriesBarTourismProfile,
    shells: ['tourism'],
  },
};

/** All Zeitreihen bar product definitions (expanded from the product catalog). */
export const TIME_SERIES_BAR_DEFINITIONS: DashboardTimeSeriesBarDefinition[] =
  expandProductCatalog(
    Object.values(TIME_SERIES_BAR_PRODUCT_CATALOG),
    createDashboardTimeSeriesBarDefinition,
  );
